import {
  makeStyles,
  tokens,
  Title2,
  Body1,
  Caption1,
} from '@fluentui/react-components';
import { ShieldProhibited24Regular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '64px 24px',
    gap: '16px',
    textAlign: 'center' as const,
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: tokens.borderRadiusLarge,
    boxShadow: tokens.shadow4,
  },
  icon: {
    fontSize: '48px',
    color: tokens.colorPaletteRedForeground1,
  },
});

interface AccessDeniedProps {
  reason?: string;
}

export function AccessDenied({ reason }: AccessDeniedProps) {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      <ShieldProhibited24Regular className={styles.icon} />
      <Title2>Access Denied</Title2>
      <Body1>You don't have permission to view this page.</Body1>
      {reason && <Caption1>{reason}</Caption1>}
      <Caption1>Contact your administrator for access.</Caption1>
    </div>
  );
}
